module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-col', {
    staticClass: "order_content"
  }, [_c('div', {}, [_c('p', {
    staticClass: "stepTitle",
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_vm._v("参展店铺")])]), _vm._v(" "), _c('div', {
    staticClass: "table_container"
  }, [_c('div', {
    staticClass: "table_inner_container",
    staticStyle: {
      "height": "auto"
    }
  }, [_c('el-table', {
    staticClass: "invoice_tab",
    staticStyle: {
      "height": "auto"
    },
    attrs: {
      "data": _vm.dataList,
      "stripe": "",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "align": "center",
      "width": "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.$index + 1))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "参展店铺",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.name))]
      }
    }])
  }), _vm._v(" "), (_vm.setType != 2) ? _c('el-table-column', {
    attrs: {
      "label": "操作",
      "fixed": "right",
      "width": "300",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.deleteBrand(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-delete"
        }), _vm._v(" 删除\r\n              ")])]
      }
    }], null, false, 3121618997)
  }, [_c('template', {
    slot: "header"
  }, [_c('button', {
    staticClass: "redBackground",
    on: {
      "click": function($event) {
        return _vm.addRelatedBrand()
      }
    }
  }, [_vm._v(" 新增 ")])])], 2) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-left": "0",
      "margin": "22px auto",
      "text-align": "center"
    }
  }, [_c('button', {
    staticClass: "el-button el-button--default cancle normal_btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toPrevStep
    }
  }, [_vm._v("\r\n          上一步\r\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "el-button el-button--default search_btn normal_btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toNextStep
    }
  }, [_vm._v("\r\n          下一步\r\n        ")])])])]), _vm._v(" "), _c('el-dialog', {
    staticClass: "add_order_cancle",
    attrs: {
      "title": "参展店铺",
      "width": "36%",
      "visible": _vm.vRelatedBrands
    },
    on: {
      "update:visible": function($event) {
        _vm.vRelatedBrands = $event
      }
    }
  }, [_c('el-form', [_c('el-form-item', {
    staticStyle: {
      "width": "100%",
      "display": "flex"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请选择店铺"
    },
    model: {
      value: (_vm.exhibitionId),
      callback: function($$v) {
        _vm.exhibitionId = $$v
      },
      expression: "exhibitionId"
    }
  }, _vm._l((_vm.exhibitingBrands), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": item.id,
        "label": item.name
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-left": "0",
      "text-align": "center"
    }
  }, [_c('button', {
    staticClass: "el-button el-button--default cancle normal_btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.vRelatedBrands = false
      }
    }
  }, [_vm._v("\r\n        取消\r\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "el-button el-button--default search_btn normal_btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.editBrand()
      }
    }
  }, [_vm._v("\r\n        保存\r\n      ")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-970368ac!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/addOrEditActive/exhibitionBrandList.vue
// module id = 1732
// module chunks = 3